module.exports = __webpack_public_path__ + "static/media/38_A.132c8d4c.png";